/** Small SVG string builders shared by the humanoid renderer and its NPC layers. */

export const createPath = (d: string, fill: string, stroke = 'none', strokeWidth = 0, opacity = 1) =>
  `<path d="${d}" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" opacity="${opacity}" />`;

export const createCircle = (cx: number, cy: number, r: number, fill: string, stroke = 'none', strokeWidth = 0, opacity = 1) => {
  const opVal = opacity !== 1 ? ` opacity="${opacity}"` : '';
  return `<circle cx="${cx}" cy="${cy}" r="${r}" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}"${opVal} />`;
};

/** Multiply-darken a #rrggbb hex color (factor 0..1; above 1 lightens, clamped). */
export function darken(hex: string, factor: number): string {
  const n = parseInt(hex.replace('#', ''), 16);
  if (Number.isNaN(n)) return hex;
  const channel = (shift: number) => Math.min(255, Math.round(((n >> shift) & 0xff) * factor));
  return `#${((channel(16) << 16) | (channel(8) << 8) | channel(0)).toString(16).padStart(6, '0')}`;
}
